import { Grade, TeachersNoNulls } from "../../utils";

export const teacherGrToFieldName = (grade: Grade): keyof TeachersNoNulls => {
  if (!grade) return "" as keyof TeachersNoNulls;

  switch (grade) {
    case "ECS-AM":
      return "grade0am";
    case "ECS-PM":
      return "grade0pm";
    default:
      if (!grade.startsWith("Gr ")) {
        console.error("Invalid grade to field", grade);
        return "" as keyof TeachersNoNulls;
      }
      return grade.replace("Gr ", "grade") as keyof TeachersNoNulls;
  }
};
